import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { selectCurrentRole } from '../../../../pages/login/authSlice';
import { changeDateFormate, datetimeToDate } from '../../../../utils/dateFormat';
import { useCreateCoachingGoalMutation } from '../goalSlice';
import DescriptionBox from '../../../../components/descriptionBox/DescriptionBox';

interface NewGoalProps {
    recipientId: string;
    authorId: string;
    setViewState: (viewState: 'read' | 'edit' | 'new') => void;
    setDisplayModal: (displayModal: boolean) => void;
    displayModal: boolean;
    authorName?: string;
}

const alphanumregex = /^[A-Za-z0-9.!, ]*$/;

export const NewGoal = (props: NewGoalProps) => {
    const [CreateCoachingGoal] = useCreateCoachingGoalMutation();
    const [title, setTitle] = useState<string>('');
    const [goalDesc, setGoalDesc] = useState<string>('');
    let currentRole: string = useSelector(selectCurrentRole);
    currentRole = currentRole.charAt(0).toUpperCase() + currentRole.slice(1) || '';
    const now = new Date();
    const handleTextChange = (e: any, type: 'title' | 'goal') => {
        const eventVal = e.target.value;
        if (type === 'title') setTitle(eventVal);
        else if (type === 'goal') setGoalDesc(eventVal);
    };
    const validate = () => {
        const errors: string[] = [];
        if (!alphanumregex.test(title.trim())) {
            errors.push('Please enter a title with valid characters');
        }
        if (!alphanumregex.test(goalDesc.trim())) {
            errors.push('Please enter a goal with valid characters');
        }
        if (title.trim().length < 3) {
            const errors: string[] = [];

            if (title.trim().length < 3) {
                errors.push('Please enter a title with atleast 3 characters');
            } else if (title.trim().length > 200) {
                errors.push('Title must be less than 200 characters');
            }
            if (goalDesc.trim().length < 10) {
                errors.push('Please enter a goal with atleast 10 characters');
            } else if (goalDesc.trim().length > 200) {
                errors.push('Goal must be less than 200 characters');
            }
            if (errors.length > 0) {
                errors.forEach((error) => toast.error(error));
                return false;
            }
        }
        return true;
    };

    const handleCancel = () => {
        props.setViewState('read');
    };
    const handleSave = () => {
        if (!validate()) return;
        // api call
        const currDate = new Date();
        const request = {
            employeeId: props.recipientId,
            authorId: props.authorId,
            goalDate: `${currDate.getFullYear()}-${currDate.getMonth() + 1}-${currDate.getDate()}`,
            goalTitle: title,
            goalDescription: goalDesc,
        };
        CreateCoachingGoal(request)
        .unwrap()
        .then((res: any) => {
            if (res?.status) {
                toast.success('Goal created successfully');
                props.setViewState('read');
            } else toast.error('Something went wrong');
        })
        .catch((error: any) => {
            toast.error(error);
        });
    };

    const renderHeader = () => {
        return (
            <div>
                <h3>Goals</h3>
            </div>
        );
    };
    return (
        <Dialog
            className="card shadow bg-body rounded mt-4 border-0"
            header={renderHeader()}
            visible={props.displayModal}
            onHide={() => {
                props.setDisplayModal(false);
                props.setViewState('read');
            }}
            style={{
                width: '66vw',
                height: '90vh',
            }}
            position="top-right"
            modal
            draggable={false}
            resizable={false}
        >
            <div className="mt-4">
                <div className="d-flex align-items-center gap-2">
                    <h4>New Goal</h4>{' '}
                    <div
                        style={{
                            backgroundColor: 'rgb(255, 153, 51)',
                            color: 'white',
                            padding: '0.2rem 0.5rem',
                            verticalAlign: 'middle',
                        }}
                    >
                        Author : {props.authorId}, {props.authorName}
                    </div>
                </div>

                <div className="logConversation p-2">
                    <h6>Title</h6>

                    <InputText
                        className="borderRadius8 w-100"
                        onChange={(e: any) => handleTextChange(e, 'title')}
                        maxLength={50}
                        value={title}
                    />
                    <div className="d-flex justify-content-end textSmall">50 character limit</div>
                    <h5>Goal Setting {'(S. M. A. R. T.)'}</h5>

                    <div className="d-flex justify-content-between mt-2">
                        <h6>TL Goal Coaching</h6>
                        <h6>Please describe the goal</h6>
                        <h6>Beginning of the Month</h6>
                    </div>
                    <DescriptionBox
                        value={goalDesc}
                        responseDescription={goalDesc}
                        limit={200}
                        onChange={(value) => {
                            const syntheticEvent = {
                                target: { value },
                            };
                            handleTextChange(syntheticEvent, 'goal');
                        }}
                    />

                    <div className="d-flex justify-content-start">
                        <div className="me-3">
                            <h6>Date</h6>
                            <span>{changeDateFormate(datetimeToDate(now))}</span>
                        </div>
                        <div>
                            <h6>Role</h6>
                            <span>{currentRole}</span>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        <Button
                            label="Cancel"
                            onClick={handleCancel}
                            className="me-2 p-2 btn-secondary"
                        />
                        <Button label="Save" onClick={handleSave} className="p-2 btn-primary" />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};
